module.exports = __webpack_public_path__ + "img/equipo_16-9.3eea3876.webp";